import { render, staticRenderFns } from "./ModalEditarConta.vue?vue&type=template&id=46d82465&"
import script from "./ModalEditarConta.vue?vue&type=script&lang=js&"
export * from "./ModalEditarConta.vue?vue&type=script&lang=js&"
import style0 from "./ModalEditarConta.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports